export default __webpack_public_path__ + "static/media/016-bread.ec20be6f.svg";